import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const brand = defineStyle({
  borderColor: "brand.500",
  borderBottomColor: "brand.100",
});

const purple = defineStyle({
  borderColor: "purple.500",
  borderBottomColor: "purple.100",
});

const gray = defineStyle({
  borderColor: "gray.500",
  borderBottomColor: "gray.100",
});

const white = defineStyle({
  borderColor: "white",
  borderBottomColor: "gray.100",
});

export const Spinner = defineStyleConfig({
  variants: {
    brand,
    purple,
    gray,
    white,
  },

  baseStyle: {
    boxSize: "20px",
    borderWidth: "2px",
    animationDuration: "0.65s",
  },
  defaultProps: {
    variant: "brand",
  },
});
